import React from "react"; 
import fruits from "../../assets/fruitslegumes.png";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { Image } from "react-bootstrap"; 


const SymfonyRealisations =()=>{
    return(
        <div className="">
        <div className="card shadow-sm">
            <h6>Calendrier FRUITS/LÉGUMES</h6>
            <Image src={fruits} style={{ height: '340px', width:"90%", margin:"auto" }} alt="calendrierfruits" fluid ="true" />
            <p className="pMemory">Appli sous Symfony <Link to={{ pathname: "https://fruits-calendar.herokuapp.com/" }} target="_blank">&nbsp;&nbsp;&nbsp;<span className="pMemory">Visiter</span><FaIcons.FaExternalLinkAlt style={{ color: "#daef0a" }} /></Link>
            </p>
        </div>
    </div>
    )
}

export default SymfonyRealisations;